import { Skeleton } from "antd-mobile";

const SpotlightTokenSkeleton = () => {
    return (
        <div className="w-[210px] border-[0.5px] border-border_2 rounded-xl py-2.5 my-0.5 px-3">
            <div className="flex items-center">
                <Skeleton className="w-[36px] h-[36px] rounded-full " />
                <Skeleton className="w-[50px] h-[24px] rounded-[2px] ml-2" />
            </div>
            <div className="mt-1">
                <Skeleton className="w-[80px] h-[22px] rounded-[2px]" />
                <div className="h-4 flex items-center mt-0.5">
                    <Skeleton className="w-[20px] h-[14px] rounded-[2px]" />
                    <Skeleton className="w-[20px] h-[14px] rounded-[2px] ml-0.5" />
                    <span className="h-3 bg-border_2 w-[1px] inline-block mx-2"></span>
                    <Skeleton className="w-[20px] h-[14px] rounded-[2px]" />
                    <Skeleton className="w-[20px] h-[14px] rounded-[2px] ml-0.5" />
                </div>
            </div>
        </div>
    );
};

export default SpotlightTokenSkeleton;
